import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';

function ImpersonateUserPage() {
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedUserId, setSelectedUserId] = useState('');
  const { fetchData, loading, error } = useFetch();
  const navigate = useNavigate();

  useEffect(() => {
    const getUsers = async () => {
      const data = await fetchData('/api/admin/users');
      if (data && !data.unauthorized) {
        setUsers(data);
      }
    };
    getUsers();
  }, [fetchData]);

  const handleImpersonate = async () => {
    if (!selectedUserId) {
      alert('Please select a user to impersonate.');
      return;
    }

    const response = await fetchData('/api/admin/impersonate', {
      method: 'POST',
      body: { userId: selectedUserId },
    });

    if (response && response.token) {
      const adminToken = localStorage.getItem('jwtToken');
      localStorage.setItem('adminToken', adminToken);
      localStorage.setItem('jwtToken', response.token);
      // Navigate to dashboard to reload the app with the new user context
      navigate('/dashboard');
    } else {
      alert('Failed to impersonate user.');
    }
  };

  const filteredUsers = users.filter(
    (user) => user.username.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <div className="container mx-auto p-4 text-white">
      <h1 className="text-2xl font-bold mb-4">Impersonate User</h1>
      {loading && <p>Loading users...</p>}
      {error && <p className="text-red-500">Error fetching users: {error.message}</p>}
      <div className="mb-4">
        <input
          type="text"
          placeholder="Search for a user..."
          className="p-2 border rounded w-full bg-gray-800"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="mb-4">
        <select
          className="p-2 border rounded w-full bg-gray-800"
          value={selectedUserId}
          onChange={(e) => setSelectedUserId(e.target.value)}
        >
          <option value="">-- Select a User --</option>
          {filteredUsers.map((user) => (
            <option key={user.id} value={user.id}>
              {user.username} ({user.email})
            </option>
          ))}
        </select>
      </div>

      <div>
        <button
          type="button"
          onClick={handleImpersonate}
          disabled={!selectedUserId || loading}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded disabled:bg-gray-500"
        >
          Impersonate User
        </button>
      </div>
    </div>
  );
}

export default ImpersonateUserPage;
